var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#21a365}.st1{fill:#107c41}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.7 34.2H128V64H78.7z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7 64H128v29.8H78.7zM29.5 34.2h49.2V64H29.5z",
    className: "st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#185b37",
    d: "M78.7 93.8V64H29.6v53.7c0 3.2 2.6 5.8 5.8 5.8h86.7c3.2 0 5.8-2.6 5.8-5.8V93.8H78.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#33c481",
    d: "M122.1 4.5H78.6v29.8H128v-24c-.1-3.2-2.7-5.8-5.9-5.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7 4.5H35.5c-3.2 0-5.8 2.6-5.8 5.8v23.9h49.1V4.5z",
    className: "st0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#17864c",
    d: "M59.5 96.5h-53C3 96.5.1 93.6.1 90.1V37.9c0-3.5 2.9-6.4 6.4-6.4h53c3.5 0 6.4 2.9 6.4 6.4v52.2c0 3.5-2.8 6.4-6.4 6.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.5 82.4l-3.9-7.1c-1.6-2.8-2.6-4.7-3.7-6.8h-.1c-.9 2.1-1.8 4-3.3 6.8L26 82.4h-7.6l10.8-18.1-10.5-17.8h7.7l3.9 7.4c1.2 2.2 2.1 4 3 6h.2c1-2.2 1.7-3.8 2.9-6l3.9-7.4h7.6L37.2 64l11.1 18.4h-7.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7 37.3V90.1c0 3.5-2.9 6.4-6.4 6.4H30.4v5.7h35.2c3.5 0 6.4-2.9 6.4-6.4V43.6c.1-3.2-2.3-5.9-5.3-6.3z",
    opacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.f3c257b1.svg";
export { ForwardRef as ReactComponent };